export const EVENTS = {
  CLOSE_ALL_DROPDOWNS: 'close-all-dropdowns',
};
